export const frData = `
  <div class="paragraph">
    <div class="title">CONDITIONS GÉNÉRALES</div>
    <div class="text-box">
      <div class="text">
        <br><br>
        Le présent service de reprise (« Service ») est fourni par Danghuan Europe S.L., société
        constituée selon le droit espagnol et enregistrée à Madrid, Espagne, 28045, sous le
        numéro de TVA B19961911 (ci-après « Danghuan »), e-mail : legal@danghuan.eu. Les
        entités OPPO, Reflection Investment B.V. pour la France et l’Espagne et OPPO UK
        Limited pour le Royaume-Uni (collectivement dénommées « OPPO ») promeuvent la
        disponibilité du présent service de reprise sur leurs sites officiels respectifs. Cependant,
        OPPO n’exploite, ne gère ni ne traite aucune partie opérationnelle du programme de
        reprise.
        <br><br>
        Le présent document régit les conditions dans lesquelles les consommateurs résidant
        dans l’Union européenne peuvent participer au programme officiel de reprise lié à l’achat
        de smartphones OPPO désignés. Le programme est exploité en stricte conformité avec
        la législation de l’Union européenne, notamment la Directive 2011/83/UE relative aux
        droits des consommateurs et le Règlement (UE) 2016/679 (RGPD) relatif à la protection
        des données personnelles.
        <br><br>
        Pour les consommateurs résidant au Royaume-Uni, le programme de reprise est régi
        par la législation britannique applicable, notamment le Consumer Rights Act 2015 et le
        UK General Data Protection Regulation (UK GDPR), qui incorpore et adapte les
        principes du Règlement (UE) 2016/679 conformément au Data Protection Act 2018.
        <br><br>
        ARTICLE 1 – CHAMP D’APPLICATION ET PRODUITS
        <br><br>
        1.1. Le Service est accessible aux personnes âgées de 18 ans ou plus résidant
        légalement dans un État membre de l’Union européenne ou au Royaume-Uni.
        <br><br>
        1.2. Les clients doivent agir en tant que particuliers (non professionnels) et avoir la
        qualité de « consommateurs » au sens de la Directive 2011/83/UE (pour les résidents
        de l’UE) ou du Consumer Rights Act 2015 (pour les résidents du Royaume-Uni).
        <br><br>
        1.3. Une seule reprise d’appareil est autorisée par transaction éligible.
        <br><br>
        1.4. Le Service est exclusivement disponible pour les clients ayant acheté un produit
        OPPO éligible (« Produit ») sur les boutiques en ligne officielles d’OPPO en France, en
        Espagne ou au Royaume-Uni, pendant la période de campagne applicable. Seuls les
        modèles désignés par OPPO sont éligibles.
        <br><br>
        1.5. L’appareil remis doit figurer parmi les modèles éligibles publiés sur le site officiel et
        satisfaire aux critères de fonctionnalité et de propriété décrits à l’article 5.
        <br><br>
        1.6. Le client peut remettre 1 (un) seul appareil usagé pour chaque Produit acheté.
        <br><br>
        ARTICLE 2 – CONDITIONS CONTRACTUELLES
        <br><br>
        2.1. Le Service fonctionne indépendamment de tout achat de Produit et ne constitue pas
        une offre groupée, combinée ou conjointe avec un fabricant, un distributeur ou un
        revendeur.
        <br><br>
        2.2. L’ensemble des responsabilités opérationnelles liées au Service, y compris la
        communication avec les clients, la logistique, l’évaluation des appareils, les paiements
        et le traitement des données personnelles, relève exclusivement de Danghuan Europe
        S.L.
        <br><br>
        2.3. Aucune disposition des présentes Conditions ne limite ni ne porte atteinte aux droits
        légaux accordés aux consommateurs par la législation applicable, y compris, sans s’y
        limiter, la Directive 2011/83/UE et le UK Consumer Rights Act 2015.
        <br><br>
        2.4. Danghuan se réserve le droit de refuser toute demande de reprise en cas de
        suspicion de fraude, d’abus ou de non-respect des présentes Conditions, notamment
        dans le cas d’une demande soumise par un tiers au nom d’un autre utilisateur.
        <br><br>
        ARTICLE 3 – PROCESSUS DE PARTICIPATION AU SERVICE
        <br><br>
        3.1. Les clients peuvent s’inscrire au Service de reprise lors du processus de commande
        sur la boutique en ligne officielle OPPO désignée.
        <br><br>
        3.2. Pour continuer, le client doit remplir le questionnaire d’auto-évaluation et soumettre
        les informations demandées concernant l’appareil, y compris l’IMEI, le modèle et l’état.
        <br><br>
        • Veuillez vous assurer que le modèle de votre ancien appareil est sélectionné
        correctement. Si une modification est nécessaire, veuillez nous contacter dès que
        possible à oppo@danghuan.eu afin que nous puissions mettre à jour les
        informations de l’appareil.
        <br><br>
        3.3. Le client doit fournir des coordonnées bancaires exactes et valides pour permettre
        le paiement lors de l’enregistrement:
        <br><br>
        • pour les résidents de l’UE/EEE, un IBAN conforme au SEPA émis par un
        établissement financier situé dans la zone SEPA;
        <br><br>
        • pour les résidents du Royaume-Uni, un compte bancaire en GBP à leur nom,
        incluant le Sort Code et le Account Number, pour un paiement via Faster Payments
        ou BACS.
        <br><br>
        3.4. Le client recevra un e-mail d’instructions de reprise dans les 24 heures suivant la
        confirmation de la livraison du nouveau Produit dans le système logistique.
        <br><br>
        3.5. Le client doit télécharger tous les documents requis (par exemple la déclaration
        d’intégrité signée) et expédier l’appareil usagé dans un délai de 10 jours calendaires à
        compter de la livraison du nouveau Produit. Un numéro de suivi valide doit confirmer
        l’expédition dans ce délai.
        <br><br>
        3.6. Le non-respect des étapes ci-dessus dans les délais impartis entraînera l’annulation
        automatique de la demande de reprise.
        <br><br>
        3.7. Les soumissions incomplètes, incohérentes ou inexactes, telles qu’un IMEI non
        correspondant ou des documents manquants, peuvent entraîner le rejet de la reprise
        sans compensation supplémentaire.
        <br><br>
        3.8. L’appareil usagé doit être emballé de manière sécurisée conformément aux
        instructions d’expédition fournies. L’expédition est prépayée par Danghuan. En cas de
        non-livraison ou de dommage pendant le transport, le client doit contacter
        oppo@danghuan.eu dans les 15 jours calendaires suivant la dernière mise à jour de
        suivi. Danghuan fournira alors l’accès au canal officiel de réclamation UPS et assistera
        le client dans le dépôt de sa demande.
        <br><br>
        Les réclamations logistiques doivent être soumises dans un délai de 60 jours à compter
        de la création de l’étiquette d’expédition. Toute compensation approuvée sera versée
        directement sur le compte IBAN fourni par le client. Danghuan n’assume aucune
        responsabilité pour les remboursements dans ces cas.
        <br><br>
        3.9. Les appareils retournés sans la déclaration d’intégrité requise ou sans la
        confirmation de vente signée ne seront pas traités. Le client sera notifié par e-mail et
        pourra demander le retour de l’appareil dans les 10 jours calendaires suivant la réception
        de la notification. Les frais de retour s’appliqueront conformément à l’article 6.3. Si
        aucune demande n’est reçue dans ce délai, Danghuan se réserve le droit de recycler ou
        d’éliminer l’appareil de manière responsable, sans autre obligation ni responsabilité.
        <br><br>
        3.10. Les produits éligibles à la reprise incluent les smartphones, montres connectées,
        écouteurs sans fil et tablettes, tels qu’ils figurent sur le site officiel d’OPPO au moment
        de la participation.
        <br><br>
        ARTICLE 4 – CONDITIONS D’ACCEPTATION DES APPAREILS
        <br><br>
        4.1. Seuls les appareils figurant sur la liste des modèles éligibles publiée sur le site
        officiel d’OPPO (y compris les smartphones, montres connectées, écouteurs sans fil et
        tablettes) sont acceptés dans le cadre du programme de reprise.
        <br><br>
        4.2. Tous les appareils doivent répondre aux normes d’évaluation et d’esthétique
        définies par Danghuan. Les appareils seront classés en Grade A, B ou C sur la base
        d’outils d’inspection certifiés et de leur état physique, comme détaillé à l’article 6.
        <br><br>
        4.3. Les appareils doivent répondre aux critères minimaux de fonctionnalité et de
        condition suivants:
        <br><br>
        – Smartphones et tablettes: doivent pouvoir s’allumer, disposer d’un écran tactile et
        d’une batterie fonctionnels, ne présenter aucun dommage physique majeur (ex: écran
        fissuré, corrosion) et être entièrement réinitialisés aux paramètres d’usine, avec la
        désactivation de tous les verrous de sécurité (PIN, iCloud Apple, compte Google FRP,
        Samsung, Xiaomi, etc.).
        <br><br>
        – Montres connectées: doivent pouvoir s’allumer, être exemptes de tout verrou de
        compte actif (ex: iCloud, Google, Samsung) et fonctionner correctement sans
        dommage physique significatif.
        <br><br>
        – Écouteurs sans fil: doivent inclure les deux écouteurs et le boîtier de charge, pouvoir
        être chargés et appairés, et ne présenter aucun dégât liquide ou fissure structurelle
        profonde.
        <br><br>
        4.4. Tous les appareils doivent être la propriété exclusive du client et ne pas être
        soumis à un contrat de location, de financement ou à un droit de propriété d’un tiers.
        Les appareils déclarés perdus, volés, contrefaits ou altérés (ex: numéro de série ou
        IMEI modifié) seront refusés sans aucune compensation.
        <br><br>
        4.5. Les appareils ne répondant pas aux critères minimaux d’éligibilité peuvent être
        retournés si le client en fait la demande dans les 7 jours suivant la notification, qui sera
        envoyée par e-mail. À défaut, ils pourront être recyclés de manière responsable. Si le
        client demande le retour d’un appareil non éligible, la procédure et les frais d’expédition
        suivront les conditions indiquées à l’article 6.3. If the customer requests the return of
        such ineligible device, the return process and shipping costs will follow the same
        conditions as described in Article 6.3.
        <br><br>
        ARTICLE 5 – DÉLAIS LOGISTIQUES ET OBLIGATIONS
        <br><br>
        5.1. Le client doit expédier son appareil usagé dans un délai de 10 jours calendaires à
        compter de la réception du nouveau Produit OPPO.
        <br><br>
        5.2. Danghuan enverra des rappels automatiques au jour 3 (D+3), au jour 6 (D+6) et au
        jour 9 (D+9) après la livraison.
        <br><br>
        5.3. Tous les appareils doivent être expédiés à l’aide de l’étiquette d’expédition prépayée
        fournie par Danghuan Europe S.L.
        <br><br>
        5.4. Si l’étiquette d’expédition n’est pas scannée par le transporteur avant le jour 15
        (D+14), la demande de reprise sera automatiquement annulée.
        <br><br>
        5.5. Les appareils doivent être emballés de manière sécurisée afin d’éviter tout
        dommage pendant le transport; Danghuan fournit les instructions d’emballage mais
        aucun matériel physique.
        <br><br>
        5.6. Les appareils reçus avec un IMEI non correspondant ou un état différent de celui
        déclaré peuvent faire l’objet d’un ajustement de valorisation ou d’une annulation.
        <br><br>
        ARTICLE 6 – INSPECTION, DEVIS ET ACCEPTATION
        <br><br>
        6.1. Les appareils sont inspectés dans un délai de 3 jours ouvrables après leur
        réception dans l’entrepôt désigné. Le processus d’inspection comprend une vérification
        <br><br>
        fonctionnelle à l’aide d’outils certifiés et une évaluation visuelle pour déterminer la
        condition esthétique (Grade A, B ou C).
        <br><br>
        6.2. Si l’état ou les caractéristiques techniques de l’appareil diffèrent de la déclaration
        initile du client, Danghuan Europe S.L. enverra un devis révisé par e-mail, précisant le
        grade ajusté et la justification correspondante.
        <br><br>
        6.3. Le client dispose de 7 jours calendaires à compter de la date de notification pour
        accepter ou refuser le devis révisé. Durant cette période, il peut demander le retour de
        son appareil.
        <br><br>
        • Pour les clients résidant en Espagne, Danghuan Europe S.L. prendra en charge
        les frais d’expédition du retour.
        <br><br>
        • Pour les clients résidant dans d’autres pays, les frais de retour seront à la
        charge du client, jusqu’à un maximum de €22 (£19 / DKK 165 / SEK 245, TVA
        incluse), à l’aide de l’étiquette prépayée officielle fournie par Danghuan. Les
        détails de paiement seront fournis par e-mail ou via le lien de paiement.
        <br><br>
        Le client peut effectuer le paiement selon les modalités suivantes:
        <br><br>
        • pour les clients UE/EEE, virement SEPA vers l’IBAN de Danghuan;
        <br><br>
        • pour les clients britanniques, virement en GBP vers le compte bancaire
        britannique de Danghuan (Sort Code et Account Number), via Faster Payments ou
        BACS.
        <br><br>
        Si le paiement n’est pas reçu dans un délai de 10 jours calendaires à compter de la
        demande, Danghuan se réserve le droit de considérer le devis révisé comme accepté
        et de traiter l’appareil en conséquence.
        <br><br>
        Tout remboursement de frais de retour payé par le client sera effectué par virement
        bancaire dans un délai de 5 jours ouvrables après vérification du paiement par
        Danghuan, sur le même compte communiqué lors de la soumission de la demande de
        reprise.
        <br><br>
        6.4. Si le client ne répond pas au devis révisé dans les 7 jours calendaires, le service
        client de Danghuan tentera de le contacter pour confirmer son acceptation ou son
        refus. Si aucune réponse n’est reçue dans les 30 jours calendaires suivant la
        notification, le devis révisé sera considéré comme refusé. Pour les clients résidant hors
        d’Espagne, des frais de retour s’appliqueront; le client doit régler le montant applicable
        à son pays dans les 5 jours suivant la réception de la demande de paiement. Une fois
        le paiement confirmé, Danghuan vérifiera la transaction sous 5 jours ouvrables et
        organiser la réexpédition vers l’adresse d’origine indiquée lors de la soumission. Le
        client sera notifié par e-mail avec les informations de suivi une fois l’envoi effectué. Le client est responsable de suivre activement l’état de l’envoi de retour et d’organiser la réception ou le retrait du colis en temps voulu, le cas échéant. Danghuan Europe S.L. informera le client à l’avance par e-mail du numéro de suivi du retour ainsi que des informations logistiques pertinentes. Si le client ne récupère pas ou ne réceptionne pas le colis dans le délai imparti par le prestataire logistique, entraînant le retour du colis ou la nécessité d’un nouvel envoi, tous les frais supplémentaires d’expédition ou de traitement seront entièrement à la charge du client. Danghuan Europe S.L. ne pourra être tenue responsable de ces frais ou des conséquences qui en découlent.
        <br><br>
        6.5. Les appareils considérés comme non éligibles en raison de dommages irréparables,
        de falsification ou de non-conformité (ex: verrouillage iCloud, vol, IMEI incorrect) ne
        feront l’objet d’aucune valorisation. Le client disposera de 7 jours calendaires à compter
        de la notification pour demander le retour; à défaut, l’appareil pourra être recyclé de
        manière responsable.
        <br><br>
        6.6. Le paiement des appareils acceptés sera effectué dans un délai de trois jours
        ouvrables à compter de la date d’acceptation, par virement bancaire SEPA.
        <br><br>
        6.7. Critères de classement des appareils:
        Les appareils sont évalués et classés comme suit, chaque catégorie de produit
        (smartphone, tablette, montre, écouteurs) étant soumise à ses propres exigences:
        <br><br>
        I. Smartphones et tablettes
        <br><br>
        Grade A – Excellent état
        <br><br>
        • L’appareil présente des signes d’usage normaux mais reste en bon état.
        <br><br>
        • Aucun éclat, fissure ou perte de peinture.
        <br><br>
        • Toutes les fonctions (écran, tactile, caméra, boutons, haut-parleur, batterie,
        connectivité, etc.) fonctionnent normalement.
        <br><br>
        • Pour les appareils Apple, la santé de la batterie ≥ 90 %.
        <br><br>
        Grade B – Légers signes d’usage
        <br><br>
        • L’appareil présente des signes d’usage normaux mais reste en bon état.
        <br><br>
        • Peut comporter 2–3 micro-rayures ou petites marques; aucun dommage majeur.
        <br><br>
        • Toutes les fonctions principales (affichage, tactile, capteurs, Bluetooth)
        fonctionnent normalement.
        <br><br>
        • Pour les appareils Apple, la santé de la batterie ≥ 80%.
        <br><br>
        Grade C – Signes visibles d’usage
        <br><br>
        • L’appareil présente des marques d’usure plus prononcées telles que multiples
        rayures, usure de peinture ou petit enfoncement.
        <br><br>
        • Une fissure légère sur l’écran est acceptable si la fonctionnalité n’est pas affectée.
        <br><br>
        • Toutes les fonctions clés (écran, tactile, caméra, connectivité) restent
        opérationnelles.
        <br><br>
        Grade D – Non récupérable / Rejeté
        <br><br>
        • L’appareil est gravement endommagé ou ne s’allume pas.
        <br><br>
        • Fissures profondes, châssis tordu, écran ou coque cassés, pièces manquantes,
        panne carte mère, corrosion, absence d’affichage ou de réponse tactile.
        <br><br>
        • L’appareil ne peut pas être connecté ni testé (ex.: verrouillage Google / iCloud /
        PIN).
        <br><br>
        • La batterie de l’appareil est gonflée ou présente d’autres problèmes ne
        respectant pas les normes de sécurité, par exemple : une surchauffe excessive
        ou le boîtier écarté par la batterie.
        <br><br>
        II. Montres connectées et bracelets
        <br><br>
        Grade A – Excellent état
        <br><br>
        • L’appareil présente des signes d’usage normaux mais reste en bon état.
        <br><br>
        • Aucun éclat, fissure, décoloration ni perte de peinture.
        <br><br>
        • Toutes les fonctions (tactile, couronne, capteurs, Bluetooth, Wi-Fi) fonctionnent
        correctement.
        <br><br>
        • Pour les appareils Apple, la santé de la batterie ≥ 90 %.
        <br><br>
        Grade B – Légers signes d’usage
        <br><br>
        • L’appareil présente des signes d’usage normaux mais reste en bon état.
        <br><br>
        • Il peut comporter 2–3 micro-rayures ou petites marques; aucun dommage majeur.
        <br><br>
        • Toutes les fonctions principales (affichage, tactile, capteurs, Bluetooth)
        fonctionnent normalement.
        <br><br>
        • Pour les appareils Apple, la santé de la batterie ≥ 80 %.
        <br><br>
        Grade C – Signes visibles d’usage
        <br><br>
        • L’appareil présente des marques d’usure visibles telles que multiples rayures,
        usure de peinture ou petits enfoncements.
        <br><br>
        • Certains capteurs ou boutons peuvent être moins réactifs mais les fonctions
        essentielles restent opérationnelles.
        <br><br>
        • L’autonomie de la batterie est légèrement réduite (&lt; 80 %).
        <br><br>
        Grade D – Non récupérable / Rejeté
        <br><br>
        • L’appareil est gravement endommagé ou ne s’allume pas.
        <br><br>
        • Écran fissuré, boutons ou couronne cassés, panne carte mère, verrouillage de
        compte (iCloud / Google / PIN) ou corrosion.
        <br><br>
        • Non éligible à la reprise.
        <br><br>
        III. Écouteurs sans fil
        <br><br>
        Grade A – Excellent état
        <br><br>
        • L’appareil est en excellent état, propre et sans rayures ni taches.
        <br><br>
        • Toutes les fonctions (son, tactile, microphone, Bluetooth, charge) fonctionnent
        normalement.
        <br><br>
        • Le boîtier de charge est intact et opérationnel.
        <br><br>
        Grade B – Légers signes d’usage
        <br><br>
        • L’appareil présente de légères traces d’usage (petites marques superficielles ou
        frottements) mais reste en bon état.
        <br><br>
        • La qualité sonore est normale; le Bluetooth est stable; le boîtier peut présenter
        de légères marques.
        <br><br>
        • Les fonctions tactile et microphone sont pleinement opérationnelles.
        <br><br>
        Grade C – Signes visibles d’usage
        <br><br>
        • L’appareil présente des marques d’usure visibles (multiples rayures, décoloration
        ou petits enfoncements).
        <br><br>
        • Le son ou le microphone peuvent être légèrement altérés mais restent
        fonctionnels.
        <br><br>
        • Le Bluetooth peut être moins stable; le boîtier présente des rayures ou
        dommages légers.
        <br><br>
        Grade D – Non récupérable / Rejeté
        <br><br>
        • L’appareil est incomplet, ne s’allume pas ou échoue aux fonctions de base.
        <br><br>
        • Écouteur ou boîtier manquant, panne de batterie, port de charge cassé,
        impossibilité d’appairage ou dégât liquide.
        <br><br>
        • Non éligible à la reprise.
        <br><br>
        6.8. Si l’appareil reçu ne correspond pas au modèle ou au numéro de série initialement
        déclaré, Danghuan contactera le client pour l’en informer. Si le nouvel appareil reçu est
        éligible au programme, un nouveau devis sera émis selon son état réel. Le client doit
        examiner et accepter ce nouveau devis, puis signer une nouvelle Déclaration de
        propriété et d’intégrité correspondant à l’appareil reçu avant que la reprise ne puisse se
        poursuivre. En l’absence d’acceptation dans un délai de sept (7) jours calendaires, le
        client peut demander le retour conformément à l’Article 6.3.
        <br><br>
        6.9. Le processus de reprise exige que le client signe et soumette la Déclaration de
        propriété et d’intégrité de l’appareil concerné. L’omission de ce document dûment
        <br><br>
        complété et signé peut entraîner le rejet de la reprise. Dans ce cas, l’appareil pourra être
        retourné sur demande, selon les conditions de l’Article 6.3, ou recyclé de manière
        responsable en l’absence de réponse.
        <br><br>
        6.10. L’estimation initiale de reprise fournie au client est indicative et soumise à vérification. Bien que la valeur estimée puisse rester valable pendant une période limitée après la livraison du nouvel appareil, Danghuan Europe S.L. se réserve le droit de réviser et d’ajuster cette estimation en fonction de facteurs incluant, sans s’y limiter, l’état de l’appareil, les fluctuations du marché et les délais de traitement.
        En raison de la nature du marché des appareils électroniques, la valeur des appareils peut diminuer avec le temps. À titre indicatif, les prix peuvent baisser progressivement chaque semaine, généralement d’environ 6 %, bien que les ajustements réels puissent varier en fonction des conditions du marché et des catégories de produits.
        Dans les cas où le processus de reprise n’est pas finalisé dans un délai raisonnable ou lorsque les conditions du marché évoluent de manière significative, la valeur initialement estimée peut ne plus être applicable.
        <br><br>
        ARTICLE 7 – CONDITIONS DE PAIEMENT
        <br><br>
        7.1. Les versements sont effectués exclusivement par virement bancaire sur un
        compte détenu au nom du client, tel qu’indiqué lors de l’enregistrement de la reprise.
        <br><br>
        7.2. Pour les clients résidant dans l’Union européenne ou l’Espace économique
        européen, le paiement est réalisé par virement SEPA vers un IBAN associé à un
        établissement financier valide situé dans la zone SEPA.
        <br><br>
        7.3. Pour les clients résidant au Royaume-Uni, le paiement peut être effectué en GBP
        par Faster Payments ou BACS sur un compte bancaire britannique, à condition que ce
        compte soit au nom du client et que les coordonnées bancaires soient complètes et
        valides.
        <br><br>
        7.4. Les cartes prépayées, comptes virtuels ou coordonnées bancaires ne
        correspondant pas au nom du client entraîneront un échec du paiement et pourront
        conduire à l’annulation de la transaction de reprise.
        <br><br>
        7.5. Danghuan Europe S.L. ne saurait être tenue responsable des retards ou erreurs
        causés par des coordonnées bancaires incomplètes, incorrectes ou expirées.
        <br><br>
        7.6. Si le client fournit des informations bancaires erronées, invalides ou ne
        correspondant pas à son identité et que le paiement est exécuté avec succès vers le
        compte communiqué, Danghuan Europe S.L. ne sera pas responsable de toute perte
        en résultant. Le client reconnaît être seul responsable de l’exactitude de ses
        coordonnées bancaires. Aucun second paiement ne sera émis dans un tel cas.
        <br><br>
        7.7. Une fois le processus de reprise finalisé, si le montant remboursable figurant dans
        la commande est inférieur au bonus de reprise applicable, seul le montant résiduel
        remboursable sera versé.
        <br><br>
        7.8. Tout bonus de reprise (le cas échéant) sera annulé en cas de remboursement de
        la commande du Produit.
        <br><br>
        7.9. Tous les frais de virement bancaire liés aux paiements de reprise sont à la charge
        de Danghuan Europe S.L.
        <br><br>
        7.10. Le montant total dû au client peut comprendre deux transferts distincts:
        <br><br>
        (a) la valeur du dispositif repris, versée directement par Danghuan;
        <br><br>
        (b) et le bonus promotionnel éventuellement octroyé par OPPO, versé séparément
        par OPPO sur les mêmes coordonnées bancaires fournies par le client.
        <br><br>
        Les deux paiements peuvent être reçus à des dates différentes en fonction des délais
        de traitement propres à chaque partie.
        <br><br>
        ARTICLE 8 – RESPONSABILITÉ ET RISQUE DE PERTE
        <br><br>
        8.1. Le client est tenu d’utiliser l’étiquette d’expédition prépayée et le transporteur
        désigné par Danghuan Europe S.L. Toute méthode d’expédition alternative annulera la
        couverture de responsabilité.
        <br><br>
        8.2. Un appareil est considéré comme perdu s’il n’est pas suivi, confirmé ou reçu par
        Danghuan Europe S.L. dans un délai de quinze (15) jours calendaires à compter de la
        remise au transporteur.
        <br><br>
        • Pour les expéditions UPS, les réclamations doivent être déposées dans un délai
        de soixante jours à compter de la date de création de l’étiquette d’expédition.
        <br><br>
        • Pour les expéditions CORREOS effectuées en Espagne, les réclamations
        doivent être déposées dès que possible, idéalement dans les quinze jours, et au
        plus tard dans un délai d’un an à compter de la date d’envoi.
        <br><br>
        Danghuan assistera le client dans la procédure de réclamation auprès du transporteur,
        laquelle dure généralement entre trente et soixante jours.
        <br><br>
        8.3. Ce cadre de responsabilité s’applique aussi bien aux envois du client vers Danghuan
        Europe S.L. qu’aux retours de Danghuan Europe S.L. vers le client.
        <br><br>
        8.4. En cas de perte confirmée dans le cadre du système logistique de Danghuan,
        Danghuan Europe S.L. assistera le client dans le dépôt d’une réclamation officielle
        auprès du service de messagerie concerné.
        <br><br>
        8.5. La responsabilité et la compensation sont strictement limitées aux cas où le client a
        utilisé l’étiquette d’expédition autorisée fournie par Danghuan Europe S.L. et où
        l’événement d’expédition est vérifiable.
        <br><br>
        8.6. En cas de perte confirmée, la compensation ne dépassera pas la valeur finale
        estimée de l’appareil, telle que déterminée avant la confirmation de la perte.
        <br><br>
        ARTICLE 9 – DONNÉES PERSONNELLES ET CONFORMITÉ AU RGPD
        <br><br>
        9.1. Toutes les données personnelles fournies par le client dans le cadre de sa
        participation au programme de reprise sont traitées en stricte conformité avec les lois
        applicables en matière de protection des données, notamment le Règlement (UE)
        2016/679 (Règlement général sur la protection des données – RGPD) pour les résidents
        de l’UE, ainsi que le UK General Data Protection Regulation (UK GDPR) et la Data
        Protection Act 2018 pour les résidents du Royaume-Uni. Danghuan Europe S.L. agit en
        <br><br>
        qualité de responsable du traitement et met en oeuvre des mesures techniques et
        organisationnelles appropriées pour garantir la confidentialité, l’intégrité et la sécurité de
        toutes les données personnelles traitées dans le cadre du programme de reprise.
        <br><br>
        9.2. Les données collectées comprennent, sans s’y limiter : nom, prénom, adresse email,
        adresse postale, numéro de téléphone, coordonnées bancaires, documents
        d’identification, IMEI de l’appareil repris, ainsi que les réponses fournies dans le
        formulaire d’évaluation.
        <br><br>
        9.3. Les données sont utilisées exclusivement aux fins suivantes : vérification d’identité,
        traitement et évaluation de la demande de reprise, gestion de la collecte et de
        l’expédition de l’appareil, assistance client, comptabilité et exécution du paiement.
        Aucune donnée personnelle n’est utilisée à des fins de marketing ni transférée à des
        tiers sans consentement explicite, sauf lorsque la loi l’exige.
        <br><br>
        9.4. Les données seront conservées uniquement pendant la durée nécessaire à
        l’exécution de la transaction de reprise et au respect des obligations légales applicables.
        Sauf exigence légale contraire, toutes les données des clients seront supprimées dans
        un délai de trente (30) jours calendaires après la finalisation du processus de reprise et
        du paiement final. Cependant, certains enregistrements pourront être conservés jusqu’à
        quatre-vingt-dix (90) jours lorsqu’ils sont nécessaires pour des audits réglementaires,
        conciliations de paiements, enquêtes antifraude ou contrôles de conformité avec les
        partenaires de marque, conformément aux lois sur la protection des données.
        <br><br>
        9.5. Le client est seul responsable de la suppression sécurisée de toutes les informations
        personnelles contenues dans son appareil avant l’expédition. Cela inclut : contacts,
        messages, photos, applications, courriels, historique de navigation, comptes et tout
        contenu confidentiel.
        <br><br>
        9.6. Le client doit également retirer toute carte SIM ou microSD et désactiver toutes les
        fonctions de sécurité telles que les verrous d’écran, mots de passe et comptes cloud
        associés (ex.: iCloud Apple, compte Google, Samsung Find My Mobile). Le non-respect
        de ces obligations pourra rendre l’appareil inéligible.
        <br><br>
        9.7. Des informations complémentaires concernant le traitement des données et les
        droits du client (accès, rectification, suppression, limitation, opposition) sont disponibles
        dans la Politique de confidentialité complète accessible sur le site officiel de Danghuan
        Europe S.L.
        <br><br>
        ARTICLE 10 – POLITIQUE DE FRAUDE ET DE NON-CONFORMITÉ
        <br><br>
        10.1. Toute soumission comportant de fausses déclarations ou portant sur des
        appareils inscrits sur liste noire, loués, falsifiés ou ne appartenant pas au client sera
        disqualifiée sans aucune compensation.
        <br><br>
        10.2. Danghuan Europe S.L. se réserve le droit d’exclure de manière permanente les
        participants concernés de toute participation actuelle ou future aux programmes de
        reprise.
        <br><br>
        10.3. Des poursuites judiciaires pourront être engagées dans les cas de fraude,
        d’usurpation d’identité ou de tentative de contournement des critères d’éligibilité à des
        fins commerciales.
        <br><br>
        ARTICLE 11 – FORCE MAJEURE
        <br><br>
        11.1. En cas de catastrophes naturelles, de restrictions gouvernementales, de
        pandémies, de mouvements sociaux ou de perturbations du transport échappant à son
        contrôle raisonnable, Danghuan Europe S.L. pourra suspendre temporairement le
        Service de reprise sans encourir de responsabilité.
        <br><br>
        11.2. Tout retard ou manquement dans l’exécution des obligations résultant de tels
        événements de force majeure ne constituera pas une violation contractuelle.
        <br><br>
        ARTICLE 12 – DROIT APPLICABLE ET JURIDICTION COMPÉTENTE
        <br><br>
        12.1. Les présentes Conditions générales sont régies et interprétées conformément au
        droit espagnol, sans préjudice des autres droits de protection dont le consommateur
        peut bénéficier en vertu de sa législation nationale.
        <br><br>
        12.2. Tout litige découlant des présentes Conditions ou s’y rapportant relève de la
        compétence exclusive des tribunaux de Madrid, Espagne, sans préjudice du droit du
        consommateur de faire valoir ses droits en matière de protection du consommateur
        devant les tribunaux de son pays de résidence.
      </div>
    </div>
  </div>
`;